var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceChargeTabIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.332 4.9974V7.01406C18.332 8.33073 17.4987 9.16406 16.182 9.16406H13.332V3.33906C13.332 2.41406 14.0904 1.66406 15.0154 1.66406C15.9237 1.6724 16.757 2.03906 17.357 2.63906C17.957 3.24739 18.332 4.08073 18.332 4.9974Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 5.83073V17.4974C1.66797 18.1891 2.4513 18.5807 3.0013 18.1641L4.4263 17.0974C4.75964 16.8474 5.2263 16.8807 5.5263 17.1807L6.90964 18.5724C7.23464 18.8974 7.76797 18.8974 8.09297 18.5724L9.49297 17.1724C9.78463 16.8807 10.2513 16.8474 10.5763 17.0974L12.0013 18.1641C12.5513 18.5724 13.3346 18.1807 13.3346 17.4974V3.33073C13.3346 2.41406 14.0846 1.66406 15.0013 1.66406H5.83464H5.0013C2.5013 1.66406 1.66797 3.15573 1.66797 4.9974V5.83073Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.04167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22656 11.4406L9.77656 6.89062",
    stroke: "#4F4F4F",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 11.25H9.94498",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16209 7.08073H5.16957",
    stroke: "#4F4F4F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceChargeTabIcon);
export default __webpack_public_path__ + "static/media/ServiceChargeTabIcon.ecb2cd9acd5b2054b8fec37bfa97ed9b.svg";
export { ForwardRef as ReactComponent };